import { Link } from 'react-router-dom';
import { FOOTER } from '../constants/content';
import { SITE_DOMAIN, SITE_NAME } from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="shell footer__grid">
        <div className="footer__col">
          <h3>{FOOTER.aboutTitle}</h3>
          <p>{FOOTER.aboutText}</p>
          <p className="footer__brand">{SITE_NAME}</p>
        </div>

        <div className="footer__col">
          <h3>{FOOTER.linksTitle}</h3>
          <ul>
            {FOOTER.links.map((link) => (
              <li key={link.label}>
                <Link to={link.href}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer__col">
          <h3>{FOOTER.policiesTitle}</h3>
          <ul>
            {FOOTER.policies.map((link) => (
              <li key={link.label}>
                <Link to={link.href}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer__col">
          <h3>{FOOTER.contactTitle}</h3>
          <p>{FOOTER.contactText}</p>
          <button type="button" className="btn btn--white" onClick={openZohoChat}>
            {FOOTER.contactCta}
          </button>
        </div>
      </div>

      <div className="shell">
        <p className="footer__disclaimer">{FOOTER.disclaimer}</p>
      </div>

      <div className="footer__bottom">
        <div className="shell">
          <p>
            © {new Date().getFullYear()} <strong>{SITE_DOMAIN}</strong> — All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
